import {
  useContext,
  useRef,
  useEffect,
  useCallback,
} from 'react';
import PropTypes from 'prop-types';

import { MediaContext } from '@playbookux/playbook-web-core';

import VjsScrubber from './vjs-scrubber';

const Scrubber = (props) => {
  const {
    time,
    onChange,
  } = props;

  const { player } = useContext(MediaContext);

  const scrubberEl = useRef(null);

  const handleChange = useCallback((value) => {
    if (onChange) {
      onChange(value);
    }
  }, [onChange]);

  useEffect(() => {
    scrubberEl.current = new VjsScrubber(player);

    player.controlBar.progressControl.seekBar.addChild(scrubberEl.current);

    return () => {
      player.controlBar.progressControl.seekBar.removeChild(scrubberEl.current);
    };
  }, [player]);

  useEffect(() => {
    if (scrubberEl.current) {
      scrubberEl.current.options({
        changeHandler: handleChange,
      });
    }
  }, [handleChange]);

  useEffect(() => {
    if (scrubberEl.current) {
      scrubberEl.current.setCurrentTime(time);
    }
  }, [time]);

  return null;
};

Scrubber.propTypes = {
  onChange: PropTypes.func,
  time: PropTypes.number.isRequired,
};

Scrubber.defaultProps = {
  onChange: null,
};

export default Scrubber;
